/** 首页英文文案（默认语言同步加载） */
export default {
    heroTitlePart1: '<strong>GBWhatsApp</strong> APK',
    heroTitleHighlight: 'Download',
    heroTitlePart2: 'Latest Version 2026',
    heroDesc:
      'Download the latest GBWhatsApp APK for Android and explore extra privacy controls, customization options, themes, and messaging features not available in the official WhatsApp app.',
    heroBtn: 'Download GBWhatsApp APK (85MB)',
    versionInfo: 'Latest Version: v18.80 | Updated: August 2026',
    tocTitle: 'Table of Contents',
    tocWhatIs: 'What is GBWhatsApp',
    tocFeatures: 'Key Features',
    tocDownload: 'Download GBWhatsApp',
    tocInstall: 'How to Download and Install GB WhatsApp',
    tocVsMods: 'GBWhatsApp vs Other MODs',
    tocPrivacy: 'Privacy Features',
    tocCustom: 'Customization Options',
    tocFaq: 'Frequently Asked Questions',
    tocAlternatives: 'Alternatives to GBWhatsApp',
    tocSafety: 'Is GBWhatsApp Safe to Download?',
    tocUpdate: 'Latest Update Features',
    tocTransfer: 'How to Transfer from WhatsApp to GB WhatsApp',
    tocAccountSafety: 'Understanding Account Safety and Ban Risks',
    tocWhyChoose: 'Why Choose GB WhatsApp',
    tocBackup: 'How to Backup GB WhatsApp Chat History',
    tocWebPc: 'Can I Use GB WhatsApp on Web or PC?',
    tocTrouble: 'Troubleshooting',
    whatIsTitle: 'What is GBWhatsApp?',
    whatIsP1:
      '<strong>GBWhatsApp</strong> is a modified version of the official WhatsApp messenger that offers enhanced features and customization options not available in the original application. Developed by independent developers, GBWhatsApp provides users with advanced privacy controls, extended media sharing capabilities, and extensive customization options that transform the messaging experience.',
    whatIsP2:
      'Unlike the official WhatsApp application, GBWhatsApp allows users to customize almost every aspect of the interface, from theme colors to font styles, and offers features like hiding online status, blue ticks, and typing indicators. This makes it an ideal choice for users who want more control over their messaging privacy and appearance.',
    whatIsP3:
      "The application is regularly updated to ensure compatibility with the latest Android versions and to add new features. GBWhatsApp v18.80, the latest version, includes improved anti-ban protection and exciting new features that make messaging more enjoyable than ever before.",
    keyFeaturesTitle: 'Key Features of <strong>GBWhatsApp</strong>',
    keyFeaturesIntro:
      'GBWhatsApp offers a comprehensive set of features that set it apart from the official WhatsApp application. Here are the most notable features:',
    downloadTitle: 'Download <strong>GBWhatsApp APK</strong>',
    downloadIntro:
      'Download the latest version of GBWhatsApp APK completely free. Our downloads are verified and safe to use.',
    downloadBtn: 'Download GBWhatsApp APK v18.80',
    downloadInfo: 'File Size: 85MB | Android 5.0+ required',
    installTitle: 'How to Download and Install <strong>GB WhatsApp</strong>',
    installIntro:
      'Follow these simple steps to install GBWhatsApp on your Android device:',
    installNoteHtml:
      '<strong>Note:</strong> Uninstalling the official WhatsApp before installing GBWhatsApp will result in losing your chat history. Always backup first!',
    cmpFeature: 'Feature',
    cmpGb: 'GBWhatsApp',
    cmpOfficial: 'WhatsApp Official',
    cmpYes: 'Yes',
    cmpNo: 'No',
    cmpLimited: 'Limited',
    cmpThousands: 'Thousands',
    cmpBuiltIn: 'Built-in',
    vsWaTitle: 'GBWhatsApp vs WhatsApp Official',
    vsWaIntroHtml:
      'While both apps allow you to send messages and make calls, <a href="/" class="jump-url">GBWhatsApp</a> offers significant advantages over the official WhatsApp application:',
    vsModsTitle: 'GBWhatsApp vs Other WhatsApp MODs',
    vsModsIntroHtml:
      'There are several WhatsApp modifications available, but <strong><a href="/" class="jump-url">GB WhatsApp</a></strong> remains one of the most popular choices. Here\'s how it compares to other popular mods:',
    vsModsFmTitle: 'GBWhatsApp vs FMWhatsApp',
    vsModsFmP:
      'Both GB WhatsApp and FMWhatsApp offer similar customization features, but <strong>GB WhatsApp</strong> is known for its more frequent updates and better anti-ban protection. FMWhatsApp has a unique theme collection, while GBWhatsApp offers more privacy options.',
    vsModsYoTitle: 'GBWhatsApp vs YoWhatsApp',
    vsModsYoP:
      'YoWhatsApp is known for its extensive theme library and granular customization options. <strong>GB WhatsApp</strong> focuses more on privacy features and regular security updates. Both apps have strong anti-ban features.',
    vsModsPlusTitle: 'GBWhatsApp vs WhatsApp Plus',
    vsModsPlusP:
      'WhatsApp Plus was one of the first WhatsApp mods available. <strong>GB WhatsApp</strong> offers more frequent updates and better compatibility with newer Android versions. GBWhatsApp also has a larger user community for support.',
    linkDlFm: 'Download FMWhatsApp',
    linkDlYo: 'Download YoWhatsApp',
    linkDlPlus: 'Download WhatsApp Plus',
    privacyTitle: 'GBWhatsApp Privacy Features',
    privacyIntro:
      'Privacy is one of the main reasons users choose GB WhatsApp. The app offers comprehensive privacy controls:',
    customTitle: 'GBWhatsApp Customization Options',
    customIntro:
      'GBWhatsApp offers endless customization possibilities to make your messaging experience unique:',
    customThemesH3: 'Themes',
    customThemesP:
      'Choose from thousands of pre-made themes or create your own custom theme. Themes can change colors, fonts, and overall appearance. New themes are added regularly to the online theme store.',
    customFontsH3: 'Fonts',
    customFontsP:
      'Change the font style throughout the app. GBWhatsApp includes multiple font options and supports adding custom fonts from your device.',
    customConvH3: 'Conversation Themes',
    customConvP:
      'Set different themes for individual chats. You can personalize each conversation with unique colors and backgrounds.',
    customHeaderH3: 'Header Styles',
    customHeaderP:
      'Customize the appearance of chat headers with different styles and colors.',
    customNotifH3: 'Notification Styles',
    customNotifP:
      'Customize notification icons and notification panel appearance.',
    antiBanTitle: 'Anti-Ban Protection',
    antiBanIntro:
      "GBWhatsApp includes built-in anti-ban protection to help keep your account safe. While no modification can guarantee 100% safety, GBWhatsApp's anti-ban features significantly reduce the risk of account suspension:",
    antiBanTipHtml:
      '<strong>Safety Tip:</strong> To minimize ban risk, avoid aggressive use of features like bulk messaging or automated tools. Use GBWhatsApp as you would use the official app for best results.',
    faqTitle: 'Frequently Asked Questions',
    altTitle: 'Alternatives to GBWhatsApp',
    altIntro:
      "If you're looking for other WhatsApp modifications, here are some popular alternatives:",
    safetyTitle: 'Is GBWhatsApp Safe to Download?',
    safetyIntro:
      'GBWhatsApp is developed by third-party developers and is not affiliated with WhatsApp Inc. However, it is generally considered safe to use when downloaded from trusted sources. Here are some safety tips:',
    safetyDisclaimer:
      'Disclaimer: GBWhatsApp is a modified version of WhatsApp and is not officially supported by WhatsApp Inc. Use at your own risk.',
    updateTitle: 'GBWhatsApp Latest Update Features',
    updateIntro:
      'The latest version of GBWhatsApp (v18.80) includes the following new features and improvements:',
    troubleTitle: 'GBWhatsApp Troubleshooting',
    troubleIntro:
      'Here are solutions to common issues you might encounter with GBWhatsApp:',
    transferTitle: 'How to Transfer from WhatsApp to GB WhatsApp',
    transferIntro:
      'Moving from the official WhatsApp app to GB WhatsApp is usually straightforward because both apps use a similar chat backup structure.',
    transferOutro:
      'Before switching, make sure your chats, photos, and videos are backed up properly. If the backup file is missing or corrupted, your previous conversations may not be restored.',
    accountSafetyTitle: 'Understanding Account Safety and Ban Risks',
    accountSafetyIntro:
      'GB WhatsApp is a modified version of WhatsApp and is not developed by the official WhatsApp team. While many users use GB WhatsApp for its extra features, there is always some risk when using unofficial messaging apps.',
    accountSafetyLead: 'To reduce potential issues:',
    accountSafetyOutro:
      'No modified WhatsApp app can guarantee permanent protection from account restrictions, so users should understand the risks before installing.',
    whyChooseTitle: 'Why Choose GB WhatsApp',
    whyChooseIntro:
      'GB WhatsApp offers additional features that are not available in the official WhatsApp application.',
    whyChooseOutro:
      'For users who want more control over how WhatsApp looks and works, GB WhatsApp provides a wider range of customization options.',
    backupTitle: 'How to Backup GB WhatsApp Chat History',
    backupIntro:
      'Creating regular backups helps protect your messages and media files.',
    backupOutro:
      'It is a good idea to back up important conversations before updating GB WhatsApp or switching to a new device. Regular backups make chat restoration much easier if something goes wrong.',
    webPcTitle: 'Can I Use GB WhatsApp on Web or PC?',
    webPcP1:
      'GB WhatsApp is mainly designed for Android, but you can also use it on a PC through third-party apps such as Android emulators. These tools create an Android environment on your computer, allowing you to install and run the GB WhatsApp APK.',
    webPcP2:
      'For WhatsApp Web, compatibility can vary between GB WhatsApp versions. If you mainly need GB WhatsApp on a computer, using an Android emulator is generally the more direct option.',
    webPcTipHtml:
      '<strong>Tip:</strong> Third-party tools are not developed or officially supported by WhatsApp or GB WhatsApp, so check their security and permissions before installing them.',
    conclusionTitle: 'Conclusion',
    conclusionP1:
      'GBWhatsApp is an excellent choice for users who want more control over their WhatsApp experience. With its extensive customization options, advanced privacy features, and regular updates, GBWhatsApp provides a superior messaging experience compared to the official WhatsApp application.',
    conclusionP2:
      "While there are some risks associated with using modified apps, GBWhatsApp's anti-ban protection and careful usage significantly minimize these risks. The app is continuously updated to ensure compatibility and security, making it a reliable choice for Android users.",
    conclusionP3:
      'Download GBWhatsApp today and discover a new way to messaging with enhanced features and complete control over your privacy!',
    keyFeatureItems: [
      {
        title: 'Privacy Controls:',
        body:
          'Hide your online status, blue ticks, second ticks, typing indicators, and recording status. You can set different privacy options for different contacts.',
      },
      {
        title: 'Custom Themes:',
        body:
          'Choose from thousands of custom themes or create your own. The theme store is regularly updated with new designs.',
      },
      {
        title: 'Extended Media Sharing:',
        body:
          'Send videos up to 90MB and images in full quality without compression. Share documents up to 100MB.',
      },
      {
        title: 'Auto Reply:',
        body:
          "Set automatic replies for when you're busy or away. Customize messages for different contacts.",
      },
      {
        title: 'Message Scheduler:',
        body:
          'Schedule messages to be sent at a specific time. Perfect for birthday wishes and important reminders.',
      },
      {
        title: 'DND Mode:',
        body:
          'Do Not Disturb mode allows you to disable internet access for GBWhatsApp only while using other apps.',
      },
      {
        title: 'Anti-Delete Messages:',
        body:
          'View deleted messages from others and see messages that were deleted by the sender.',
      },
      {
        title: 'Custom Fonts:',
        body:
          'Change font styles across the app. Choose from a variety of fonts or use your own.',
      },
      {
        title: 'Status Downloader:',
        body:
          'Download status videos and images from your contacts before they expire.',
      },
      {
        title: 'Multiple Accounts:',
        body:
          'Run multiple GBWhatsApp accounts on a single device using the built-in parallel app feature.',
      },
      {
        title: 'App Lock:',
        body:
          'Protect your chats with a password, fingerprint, or face unlock. You can lock individual chats or the entire app.',
      },
      {
        title: 'No Ads:',
        body: 'Enjoy an ad-free messaging experience without any interruptions.',
      },
    ],
    featureScreenshots: [
      {
        src: require('@/assets/gbwaap-features/feature-1.webp'),
        alt: 'GBWhatsApp feature screenshot',
      },
      {
        src: require('@/assets/gbwaap-features/feature-2.webp'),
        alt: 'GBWhatsApp chat screenshot',
      },
      {
        src: require('@/assets/gbwaap-features/feature-3.webp'),
        alt: 'GBWhatsApp privacy settings screenshot',
      },
      {
        src: require('@/assets/gbwaap-features/feature-4.webp'),
        alt: 'GBWhatsApp theme screenshot',
      },
      {
        src: require('@/assets/gbwaap-features/feature-5.webp'),
        alt: 'GBWhatsApp settings screenshot',
      },
    ],
    downloadDetails: [
      { label: 'App Name', value: 'GB WhatsApp' },
      { label: 'Size', value: '85MB' },
      { label: 'Version', value: 'V18.80' },
      { label: 'Support OS', value: 'Android' },
      { label: 'Category', value: 'Chat app, mod app' },
      { label: 'Root', value: 'No' },
      { label: 'License', value: 'Free' },
    ],
    installSteps: [
      {
        title: 'Backup Your Chats:',
        body:
          'Open WhatsApp, go to Settings > Chats > Chat Backup, and create a backup to Google Drive or local storage.',
      },
      {
        title: 'Enable Unknown Sources:',
        body:
          'Go to Settings > Security > Install unknown apps (or Settings > Apps > Special access > Install unknown apps) and enable it for your file browser.',
      },
      {
        title: 'Download the APK:',
        body:
          'Click the download button above and save the GBWhatsApp APK file to your device.',
      },
      {
        title: 'Install the APK:',
        body:
          'Open the downloaded file and tap Install. Wait for the installation to complete.',
      },
      {
        title: 'Verify Your Number:',
        body:
          'Open GBWhatsApp and verify your phone number. You can restore your chat backup during setup.',
      },
      {
        title: 'Enjoy:',
        body: 'Start using GBWhatsApp with all its enhanced features!',
      },
    ],
    transferSteps: [
      'Open WhatsApp and create a local chat backup.',
      'Locate the WhatsApp backup folder on your device.',
      'Install GB WhatsApp APK.',
      'Verify your phone number.',
      'Allow GB WhatsApp to access storage files.',
      'Restore the detected backup when prompted.',
    ],
    accountSafetyItems: [
      'Download updated versions regularly.',
      'Avoid spam or bulk messaging activities.',
      'Keep backups of important chats.',
      'Use a trusted APK source.',
    ],
    whyChooseItems: [
      {
        title: 'More Privacy Controls',
        body: 'Hide online status, blue ticks, typing indicators, and other activity information.',
      },
      {
        title: 'Better Customization',
        body: 'Change themes, fonts, chat styles, and interface colors to personalize your experience.',
      },
      {
        title: 'Enhanced Media Sharing',
        body: 'Send larger files, higher-quality images, and longer videos with fewer limitations.',
      },
      {
        title: 'Extra Messaging Features',
        body: 'Access tools such as message scheduling, auto reply, and status downloading.',
      },
    ],
    backupSteps: [
      'Open GB WhatsApp Settings.',
      'Go to Chats.',
      'Select Chat Backup.',
      'Create a new local backup.',
      'Save the backup folder in a secure location if possible.',
    ],
    cmpRows: [
      { feat: 'Hide Online Status', gb: 'yes', wo: 'no' },
      { feat: 'Hide Blue Ticks', gb: 'yes', wo: 'limited' },
      { feat: 'Custom Themes', gb: 'thousands', wo: 'limited' },
      { feat: 'Video Size Limit', gb: '90MB', wo: '16MB' },
      { feat: 'Message Scheduler', gb: 'yes', wo: 'no' },
      { feat: 'App Lock', gb: 'builtIn', wo: 'no' },
      { feat: 'Status Downloader', gb: 'yes', wo: 'no' },
      { feat: 'Multiple Accounts', gb: 'yes', wo: 'no' },
    ],
    privacyItems: [
      {
        title: 'Hide Online Status:',
        body:
          "Appear offline while using the app. Your contacts won't know you're online.",
      },
      {
        title: 'Hide Blue Ticks:',
        body:
          'Read messages without letting the sender know. No blue checkmarks will appear.',
      },
      {
        title: 'Hide Second Ticks:',
        body:
          "Show messages as delivered without showing when they're read.",
      },
      {
        title: 'Hide Typing Indicator:',
        body: 'Type messages without the other person seeing "typing..."',
      },
      {
        title: 'Hide Recording Indicator:',
        body:
          'Record voice messages without showing the recording status.',
      },
      {
        title: 'Ghost Mode:',
        body:
          'Use the app completely unnoticed with the ghost mode feature.',
      },
      {
        title: 'View Deleted Messages:',
        body:
          'See messages that others have deleted using the anti-delete feature.',
      },
      {
        title: 'Privacy for Specific Contacts:',
        body: 'Set different privacy options for individual contacts.',
      },
    ],
    antiBanItems: [
      {
        title: 'Regular Updates:',
        body:
          'The development team releases updates to maintain compatibility and fix security issues.',
      },
      {
        title: 'Official Servers:',
        body:
          'GBWhatsApp uses official WhatsApp servers for communication, reducing detection risk.',
      },
      {
        title: 'Privacy-First Approach:',
        body:
          'The app is designed to be privacy-focused, minimizing suspicious activity.',
      },
      {
        title: 'Beta Testing:',
        body: 'New features are tested thoroughly before public release.',
      },
    ],
    faqItems: [
      {
        q: 'Is GBWhatsApp safe to use?',
        a:
          'Yes, GBWhatsApp is generally safe to use with proper precautions. The app includes anti-ban protection, but as with any modified app, there is a small risk. Always download from trusted sources and keep your chat backups.',
      },
      {
        q: 'Can I use GBWhatsApp alongside the official WhatsApp?',
        a:
          'Yes, you can use both apps simultaneously on the same device. Each app requires a different phone number for verification. You can also use GBWhatsApp\'s built-in parallel app feature to run multiple accounts.',
      },
      {
        q: 'Will my chat history transfer to GBWhatsApp?',
        a:
          'Yes, you can restore your chat backup during the initial setup of GBWhatsApp. Make sure to create a backup in the official WhatsApp first before switching.',
      },
      {
        q: 'Does GBWhatsApp support dark mode?',
        a:
          'Yes, GBWhatsApp includes multiple dark mode themes and a built-in dark mode option. You can also create custom dark themes to suit your preferences.',
      },
      {
        q: 'How often is GBWhatsApp updated?',
        a:
          'GBWhatsApp is updated regularly, typically every few weeks. Updates include new features, bug fixes, and security improvements to maintain compatibility with the latest Android versions.',
      },
      {
        q: 'Can I transfer GBWhatsApp to another phone?',
        a:
          'Yes, you can transfer GBWhatsApp by creating a full backup within the app settings. Copy the backup files to your new device and restore them during GBWhatsApp installation.',
      },
      {
        q: 'What should I do if GBWhatsApp is not installing?',
        a:
          'If installation fails, make sure Unknown Sources is enabled in your settings, clear cache from your file manager, and ensure you have enough storage space. Also, verify the APK file is not corrupted by re-downloading.',
      },
      {
        q: 'Can I get banned for using GBWhatsApp?',
        a:
          'While GBWhatsApp includes anti-ban protection, there is always a small risk of account suspension. To minimize risk, avoid aggressive use of automation features and use the app as you would use the official WhatsApp.',
      },
    ],
    altCards: [
      {
        href: '/fmwhatsapp/',
        name: 'FMWhatsApp',
        desc: 'Popular WhatsApp mod with unique theme collection and enhanced features.',
      },
      {
        href: '/yowhatsapp/',
        name: 'YoWhatsApp',
        desc: 'Known for extensive customization and large theme library.',
      },
      {
        href: '/ogwhatsapp/',
        name: 'OGWhatsApp',
        desc: 'Modified version with unique features and privacy controls.',
      },
      {
        href: '/jtwhatsapp/',
        name: 'JTWhatsApp',
        desc: 'Feature-rich WhatsApp modification with regular updates.',
      },
      {
        href: '/mbwhatsapp/',
        name: 'MBWhatsApp',
        desc: 'Modern WhatsApp mod with sleek design and features.',
      },
      {
        href: '/whatsapp-plus/',
        name: 'WhatsApp Plus',
        desc: 'One of the original WhatsApp mods with proven stability.',
      },
      {
        href: '/gold-whatsapp/',
        name: 'Gold WhatsApp',
        desc: 'Premium gold-themed WhatsApp mod with exclusive customization features.',
      },
      {
        href: '/red-whatsapp/',
        name: 'Red WhatsApp',
        desc: 'Vibrant WhatsApp mod with stunning red theme and enhanced features.',
      },
      {
        href: '/blue-whatsapp/',
        name: 'Blue WhatsApp',
        desc: 'Elegant WhatsApp mod with beautiful blue theme and customization options.',
      },
    ],
    safetyItems: [
      {
        title: 'Download from Trusted Sources:',
        body:
          'Always download GBWhatsApp from reputable websites to avoid malware or fake versions.',
      },
      {
        title: 'Check Permissions:',
        body:
          'Review the permissions requested by the app. GBWhatsApp needs certain permissions to function properly.',
      },
      {
        title: 'Keep Backups:',
        body: 'Regularly backup your chats to avoid data loss.',
      },
      {
        title: 'Update Regularly:',
        body:
          'Keep GBWhatsApp updated to benefit from the latest security patches.',
      },
      {
        title: 'Use Anti-Ban Features:',
        body:
          'Enable anti-ban protection in the app settings for added security.',
      },
    ],
    updateItems: [
      {
        title: 'Improved Anti-Ban Protection:',
        body:
          'Enhanced security measures to reduce the risk of account suspension.',
      },
      {
        title: 'New Theme Options:',
        body: 'Added 50+ new themes to the online theme store.',
      },
      {
        title: 'Bug Fixes:',
        body:
          'Resolved various issues reported by users in previous versions.',
      },
      {
        title: 'Performance Improvements:',
        body: 'Optimized app performance for smoother experience.',
      },
      {
        title: 'Enhanced Privacy:',
        body: 'Added new privacy options including ghost mode improvements.',
      },
      {
        title: 'Media Quality:',
        body:
          'Improved image and video compression for better quality sharing.',
      },
      {
        title: 'New Font Styles:',
        body: 'Added 20+ new font options for customization.',
      },
      {
        title: 'Android 15 Support:',
        body: 'Full compatibility with the latest Android version.',
      },
    ],
    troubleSections: [
      {
        h3: 'GBWhatsApp Not Installing',
        lead: "If you're having trouble installing GBWhatsApp, try these solutions:",
        tips: [
          'Enable "Install unknown apps" in your device settings',
          'Clear your browser cache and download the APK again',
          'Ensure you have sufficient storage space',
          'Disable battery optimization for GBWhatsApp',
        ],
      },
      {
        h3: 'GBWhatsApp Crashing',
        lead: 'If GBWhatsApp keeps crashing:',
        tips: [
          'Clear app cache from device settings',
          'Update GBWhatsApp to the latest version',
          'Reinstall the application',
          'Check for conflicting apps',
        ],
      },
      {
        h3: 'Unable to Verify Phone Number',
        lead: 'If verification fails:',
        tips: [
          'Check your internet connection',
          'Verify your phone number is correct',
          'Try verification via SMS instead of call',
          'Clear app data and try again',
        ],
      },
      {
        h3: 'Chat Backup Issues',
        lead: "If you're having trouble with backups:",
        tips: [
          'Ensure Google Drive is properly configured',
          'Check available Google Drive storage',
          'Use local backup as an alternative',
          'Verify the same WhatsApp version for backup and restore',
        ],
      },
    ],
  };
